export default function FooterBlock() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#efe5d3] text-[#5d5245]">
      {/* 品牌声明区 */}
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#262019] text-white">
                <i className="ri-fire-fill text-xl text-[#e8603c]"></i>
              </span>
              <span className="font-display text-2xl font-black text-[#262019]">51黑料</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-[#6b5f51]">
              51黑料深挖频道，专注把「对不上的口径」摆上桌面。起底有据、扒皮有证、实锤留痕——这里归档的是可被公开证据支撑的线索，不是情绪。
            </p>
            <p className="mt-4 text-xs leading-6 text-[#8a7a67]">
              本站内容以可查证公开信息与投稿线索为基础，面向线索整理与信息比对用途。涉及个人隐私、未成年人及司法程序中信息均做脱敏处理；若内容有误，欢迎通过勘误通道联系更正。
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm font-bold text-[#262019]">栏目导航</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                ['实锤快讯', 'rexian'],
                ['人物起底', 'qidi'],
                ['事件扒皮', 'shichui'],
                ['分类档案', 'dangan'],
                ['围观热度', 'tuolu'],
              ].map(([label, id]) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    className="flex items-center gap-2 text-[#6b5f51] transition hover:text-[#c83424]"
                  >
                    <i className="ri-arrow-right-s-line text-[#c9bdab]"></i>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-sm font-bold text-[#262019]">站点公约</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                '阅读与可信度分级规则',
                '线索提交与隐私保护',
                '勘误申请与复核流程',
                '内容转载授权说明',
                '关于本站 · 编审原则',
              ].map((t) => (
                <li key={t} className="flex items-center gap-2 text-[#6b5f51]">
                  <i className="ri-arrow-right-s-line text-[#c9bdab]"></i>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* 版权条 */}
      <div className="border-t border-[#d8cbb6]">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-[#8a7a67] sm:flex-row md:px-6">
          <p>© {year} 51黑料 · 深挖档案室. All clues archived.</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="flex items-center gap-1">
              <i className="ri-verified-badge-line text-[#c83424]"></i>信源人工复核
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line text-[#c83424]"></i>脱敏与隐私保护
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-error-warning-line"></i>不实信息勘误
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}